import appConstants from '../../../../constants';
import computeClassName from '../../../../utils/computeClassName';
import computeTagName from '../../../../utils/computeTagName';

const constants = Object.freeze({
  CLASSNAME_BASE: 'font-normal text-cc-body-small text-cc-muted-contrast',
  TAG_DEFAULT : 'p',
});

const propsDefaults = Object.freeze({
  tagName: constants.TAG_DEFAULT,
});

export default function Copyrights({ tag = propsDefaults.tagName, className = ''}) {
  const ComputedTagName = computeTagName(tag, constants.TAG_DEFAULT);
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
    <ComputedTagName className={computedClassName}>
      <span>&copy;{appConstants.COPYRIGHT_YEAR}</span>&nbsp;<span>Cisco Systems, Inc.</span>
    </ComputedTagName>
  );
}
